import React from "react";
import SectionHeader from "../../../includes/SectionHeader/SectionHeader";

const HomeServicesTitle = () => {
  return (
    <SectionHeader
      title="Services"
      style={{ margin: "3rem 0" }}
      className="__sweven_home-services--title"
    />
  );
};

export default HomeServicesTitle;
